export const c_skeleton_m_text_4xl_Height = {
  "name": "--pf-c-skeleton--m-text-4xl--Height",
  "value": "calc(2.25rem * 1.3)",
  "var": "var(--pf-c-skeleton--m-text-4xl--Height)"
};
export default c_skeleton_m_text_4xl_Height;